import type { ApiUserUsername } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiUserPrivateProfile } from './types/ApiUserPrivateProfile';
import type { ApiUserProfile } from './types/ApiUserProfile';

type ApiResponse =
  | {
      type: 'USER';
      data: ApiUserProfile;
    }
  | {
      type: 'PRIVATE_USER';
      data: ApiUserPrivateProfile;
    };

function mapResponse(
  response: ApiResponse,
): ApiUserProfile | ApiUserPrivateProfile {
  return response.data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (username: ApiUserUsername) =>
    `/data/website/users/by-username/${username}`,
  mapResponse,
});

// Exports

export const apiIsomorphicFetchUserProfile = endpoint.createIsomorphicFetchFn();
